import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { ITyped } from '../../shared/interfaces/typed.interface';
import { DashboardComponentTypesEnum } from '../reports.enum';
import { TabContent } from './tab-content.model';

export const TAB_SCHEMA = Object.freeze({
  TYPE: '',
  GROUP: 0,
  TABS: List<TabContent>([]),
});
const RECORD = generateSchema(TAB_SCHEMA);
const KEYS: any = generateKeys(TAB_SCHEMA);

export class Tab extends Record(RECORD) implements ITyped {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.TABS,
        value: props.get(KEYS.TABS)
          ? this.tabs.map((params) => new TabContent(params))
          : List<TabContent>([]),
      },
    ]);

    return selfModel as Tab;
  }

  get type(): string {
    return DashboardComponentTypesEnum.tab;
  }

  get group(): number {
    return this.get(KEYS.GROUP);
  }

  get tabs(): List<TabContent> {
    return this.get(KEYS.TABS);
  }
}
